// BasedOnSelect.jsx
import React, { useEffect, useState } from 'react';
import { Box, Typography, Select, MenuItem } from '@mui/material';

import { setDbDateRange, setResetPeriod } from '../../../redux/reducers/DashboardSlice';
import { useDispatch, useSelector } from 'react-redux';
import theme from '../../../styles/Themecolors';

const BasedOnSelect = () => {
  const dispatch = useDispatch();
  const [invDueDateRange, setInvDueDateRange] = useState('invoiceDate');

  const dashboardData = useSelector((state) => state?.DashboardDataReducer);

  const persistedBasedOn = dashboardData['bsPeriod']?.basedOn ?? 'invoiceDate';
  const handleBasedOnChange = (val) => {
    setInvDueDateRange(val);
    dispatch(setDbDateRange({ outerKey: 'bsPeriod', innerKey: 'basedOn', value: val }));
  };
  useEffect(() => {
    setInvDueDateRange(persistedBasedOn);
  }, [persistedBasedOn]);
  return (
   <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'start',
          mr:1
        }}>
      <Typography
        sx={{
          marginTop: '5px',
          marginRight: '6px',
          color: theme?.palette?.TmId.id?.toString().includes('9') ? 'white' : 'black',
          whiteSpace: 'nowrap',
        }}
        variant="subtitle1"
      >
        Based On
      </Typography>

      <Select
        size="medium"
        value={invDueDateRange}
        sx={{ minWidth: '185px' }}
        displayEmpty
        renderValue={(val) => {
          if (!val) return 'Select Option';
          const options = { invoiceDate: 'Invoice Date', dueDate: 'Due Date' };
          return options[val] || '';
        }}
        MenuProps={{
          PaperProps: { elevation: 0, sx: { boxShadow: 'none', border: '1px solid #ccc' } },
          disableAutoFocusItem: true,
          disableScrollLock: true,
        }}
        onChange={(e) => handleBasedOnChange(e.target.value)}
      >
        <MenuItem value="invoiceDate">Invoice Date</MenuItem>
        <MenuItem value="dueDate">Due Date</MenuItem>
      </Select>
    </Box>
  );
};

export default BasedOnSelect;
